export function parseValue(value, type) {
  switch (type.toLowerCase()) {
    case "number":
    case "starrating":
      return Number(value);
    default:
      return value;
  }
}

export function isCharacterKey(evt) {
  if (typeof evt.which == "number" && evt.which > 0) {
    // In other browsers except old versions of WebKit, evt.which is
    // only greater than zero if the keypress is a printable key.
    // We need to filter out backspace and ctrl/alt/meta key combinations
    return !evt.ctrlKey && !evt.metaKey && !evt.altKey && evt.which !== 8;
  }
  return false;
}

export function getRowHeight() {
  return parseFloat(getComputedStyle(document.documentElement).fontSize) * 4;
}
